import { useQuery } from '@tanstack/react-query';
import { ROLES, VERIFICATION_STATUS } from '../../constants';
import { getPractiseType } from '../../utils';
import { getRoleManagementList } from '../../services';

const getSelectedRoleForTabs = (role: string, tab: number) => {
  if (role === ROLES.SUPER_ADMIN) {
    if (tab === 0) return ROLES.PRACTISE_ADMIN;
    if (tab === 1) return ROLES.DOCTOR;
    return '';
  }

  if (tab === 0) return ROLES.DOCTOR;
  if (tab === 1) return ROLES.DEPT_ADMIN;
  if (tab === 2) return ROLES.OTHER;

  return '';
};

export const useRoleManagementTable = ({
  rowsPerPage,
  page,
  selectedTab,
  userRole,
  generateSignedUrl,
  pageTimestamps,
  setPageTimestamps
}: {
  rowsPerPage: number;
  page: number;
  selectedTab: number;
  userRole: string;
  generateSignedUrl: (url: string, token: string) => Promise<string>;
  pageTimestamps: Map<number, string>;
  setPageTimestamps: React.Dispatch<React.SetStateAction<Map<number, string>>>;
}) => {
  return useQuery({
    queryKey: ['role-management-table', rowsPerPage, page, selectedTab, userRole],
    queryFn: async () => {
      const currentPageTimestamp = page === 0 ? undefined : pageTimestamps.get(page - 1);

      const response = await getRoleManagementList(
        rowsPerPage,
        currentPageTimestamp as string,
        VERIFICATION_STATUS.VERIFIED,
        true,
        getPractiseType(userRole) as string,
        getSelectedRoleForTabs(userRole, selectedTab),
        generateSignedUrl
      );

      if (response.lastUpdatedAt) {
        setPageTimestamps((prev) => {
          const next = new Map(prev);
          next.set(page, response.lastUpdatedAt!);
          return next;
        });
      }

      return response;
    },
    enabled: Boolean(userRole)
  });
};
